import type { CommonPlugin } from "zudoku";

export const FaviconPlugin: CommonPlugin = {
  getHead: () => (
    <>
      <link
        rel="icon"
        type="image/png"
        href="https://cdn.payonify.com/favicon/favicon-96x96.png"
        sizes="96x96"
      />
      <link
        rel="icon"
        type="image/svg+xml"
        href="https://cdn.payonify.com/favicon/favicon.svg"
      />
      <link
        rel="shortcut icon"
        href="https://cdn.payonify.com/favicon/favicon.ico"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="https://cdn.payonify.com/favicon/apple-touch-icon.png"
      />
      <meta name="apple-mobile-web-app-title" content="Payonify" />
      <link
        rel="manifest"
        href="https://cdn.payonify.com/favicon/site.webmanifest"
      />
    </>
  ),
};
